import { render, staticRenderFns } from "./OrdersStatus.vue?vue&type=template&id=a8850544&"
import script from "./OrdersStatus.vue?vue&type=script&lang=js&"
export * from "./OrdersStatus.vue?vue&type=script&lang=js&"
import style0 from "./OrdersStatus.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports